var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChimneyBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.207,
    height: 23.465,
    viewBox: "0 0 26.207 23.465",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#579ffb;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M25.76,22.246a.942.942,0,0,0-.658-.126l-.211-10.3a.943.943,0,0,0-.943-.924H21.2a.944.944,0,0,0-.943.924l-.222,10.832a.94.94,0,0,0-1.277-.451l-.5.249V17.065a.943.943,0,0,0-.943-.943H16.178a.943.943,0,0,0-.943.943v6.9l-1.188.593V23.049a.943.943,0,0,0-1.364-.844L7.967,24.557V23.049A.943.943,0,0,0,6.6,22.2L.522,25.237A.944.944,0,0,0,0,26.082V33.42a.943.943,0,0,0,.943.943h24.32a.943.943,0,0,0,.943-.943V23.049A.943.943,0,0,0,25.76,22.246ZM5.3,31.127a.943.943,0,0,1-.943.943h-1.7a.943.943,0,0,1-.943-.943V29.953a.943.943,0,0,1,.943-.943h1.7a.943.943,0,0,1,.943.943Zm7.238,0a.943.943,0,0,1-.943.943H9.9a.943.943,0,0,1-.943-.943V29.953a.943.943,0,0,1,.943-.943h1.7a.943.943,0,0,1,.943.943Zm7.238,0a.943.943,0,0,1-.943.943h-1.7a.943.943,0,0,1-.943-.943V29.953a.943.943,0,0,1,.943-.943h1.7a.943.943,0,0,1,.943.943Z",
    transform: "translate(0 -10.899)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChimneyBlue);
export default __webpack_public_path__ + "static/media/chimney_blue.2efda3e756f4e244a844a3b7842872b9.svg";
export { ForwardRef as ReactComponent };